export default __webpack_public_path__ + "static/media/art-4-seedlings-sm.e58f0b14.jpg";